import { addEntity } from '@/lib/entity/addEntity'
import { removeEntityById } from '@/lib/entity/removeEntityById'
import { replaceEntityById } from '@/lib/entity/replaceEntityById'
import { IAction } from '@/redux/actions/action-helpers'
import { CompanyCarProgramsTypes } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'

export function companyCarProgramsReducer(state: ApplicationState['companyCarPrograms'] = [], action: IAction) {
	switch (action.type) {
		case CompanyCarProgramsTypes.GetCompanyCarPrograms.SUCCESS:
			return action.payload
		case CompanyCarProgramsTypes.CreateCompanyCarProgram.SUCCESS:
			return addEntity(state, action.payload)
		case CompanyCarProgramsTypes.UpdateCompanyCarProgram.SUCCESS:
			return replaceEntityById(state, action.payload)
		case CompanyCarProgramsTypes.DeleteCompanyCarProgram.SUCCESS:
			return removeEntityById(state, action.requestPayload.id)
		default:
			return state
	}
}
